import { styled } from '@olxeu-jobs/ui';
import { Platform } from '~types';

export const Paper = styled('div', ({ $theme }) => ({
  backgroundColor: $theme.colors['background-global-primary'],
  borderTopLeftRadius: $theme.radii[4],
  borderTopRightRadius: $theme.radii[4],
  borderBottomRightRadius: $theme.radii[4],
  borderBottomLeftRadius: $theme.radii[4],
  paddingTop: $theme.space[16],
  paddingRight: $theme.space[16],
  paddingBottom: $theme.space[16],
  paddingLeft: $theme.space[16],
  scrollMarginTop: $theme.space[16],
  ...($theme.platform === Platform.DESKTOP && {
    paddingTop: $theme.space[24],
    paddingRight: $theme.space[24],
    paddingBottom: $theme.space[24],
    paddingLeft: $theme.space[24],
  }),
}));
